module.exports = __webpack_public_path__ + "img/C-range.08dca83b.svg";